import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SanctuaryHero from "./sections/SanctuaryHero";
import CuratedCollections from "./sections/CuratedCollections";
import LatestFromTheJournal from "./sections/LatestFromTheJournal";
import TheClarityToolkit from "./sections/TheClarityToolkit";
import OurPhilosophy from "./sections/OurPhilosophy";
import ReaderFavorites from "./sections/ReaderFavorites";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SanctuaryHero />
      <CuratedCollections />
      <LatestFromTheJournal />
      <TheClarityToolkit />
      <OurPhilosophy />
      <ReaderFavorites />
      <SiteFooter />
    </div>;
}